/*
 *	Copyright (c) 2011-2022 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Utils')
    .factory('fileDownload', ['$document', '$window', '$timeout', 'flashMessagesService', function ($document, $window, $timeout, flash) {
        return function (downloadURL) {
            const regExpIsIos = new RegExp('iphone|ipod|ipad', 'i');

            if (regExpIsIos.test($window.navigator.userAgent)) {
                $window.downloadWindow = $window.open(downloadURL);
                $window.downloadWindow.onload = function () {
                    var error = angular.element(this.document).text();

                    if (_handleError(error)) { // only close the window if the text in the window is an error (it can be a preview for text document in iOS)
                        this.close();
                    }
                };
            } else {
                var
                    iframe = angular.element('<iframe src="' + downloadURL + '" class="hide" name="download"/>');

                iframe.on('load', function () {
                    var error = iframe.contents().text();

                    _handleError(error);
                });
                $document.find('body').append(iframe);
            }
        };

        function _handleError(error) {
            if (error) {
                try {
                    var parsedError = JSON.parse(error);

                    $timeout(function () {
                        flash.add(parsedError.error.message, flash.ERROR);
                    });

                    return true;
                } catch (e) {
                    return false;
                }
            }
        }
    }]);
